module.exports = __webpack_public_path__ + "static/media/iconReport.b571b68e.svg";